export { Discussions as default } from './discussions';
